import { create } from 'zustand'

type Theme = 'light' | 'dark'

interface ThemeState {
  theme: Theme
  toggleTheme: () => void
  setTheme: (theme: Theme) => void
}

const THEME_STORAGE_KEY = 'cloudsent_theme'

function getInitialTheme(): Theme {
  const stored = localStorage.getItem(THEME_STORAGE_KEY)
  if (stored === 'light' || stored === 'dark') {
    return stored
  }

  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark'
  }

  return 'light'
}

function applyTheme(theme: Theme): void {
  if (theme === 'dark') {
    document.documentElement.classList.add('dark')
    localStorage.setItem(THEME_STORAGE_KEY, theme)
    return
  }

  document.documentElement.classList.remove('dark')
  localStorage.setItem(THEME_STORAGE_KEY, theme)
}

export const useThemeStore = create<ThemeState>((set) => {
  const initialTheme = getInitialTheme()
  applyTheme(initialTheme)

  return {
    theme: initialTheme,

    toggleTheme: () => {
      set((state) => {
        const newTheme = state.theme === 'light' ? 'dark' : 'light'
        applyTheme(newTheme)
        return { theme: newTheme }
      })
    },

    setTheme: (theme: Theme) => {
      applyTheme(theme)
      set({ theme })
    },
  }
})
